import { Link } from 'react-router-dom';
import { TrendingUp } from 'lucide-react';
import { useCookieConsentContext } from './cookies/CookieConsentManager';

export function MarketingFooter() {
  const currentYear = new Date().getFullYear();
  const { openPreferences } = useCookieConsentContext();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-1">
            <div className="mb-4 flex items-center gap-2">
              <div className="w-9 h-9 bg-blue-600 rounded-lg flex items-center justify-center">
                <TrendingUp className="text-white" size={20} />
              </div>
              <span className="text-lg font-bold text-white">TrezoOne</span>
            </div>
            <p className="text-sm text-gray-400 mb-4">
              Pilotage financier simple pour dirigeants de TPE, PME et associations.
            </p>
            <Link
              to="/beta-founders"
              className="inline-block text-xs bg-blue-600 text-white px-3 py-1.5 rounded-lg hover:bg-blue-700 transition-colors font-medium"
            >
              5 mois offerts — Beta Founders
            </Link>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Produit</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm hover:text-blue-400 transition-colors">Accueil</Link></li>
              <li><Link to="/fonctionnalites" className="text-sm hover:text-blue-400 transition-colors">Fonctionnalités</Link></li>
              <li><Link to="/tarifs" className="text-sm hover:text-blue-400 transition-colors">Tarifs</Link></li>
              <li><Link to="/clients" className="text-sm hover:text-blue-400 transition-colors">Clients</Link></li>
              <li><Link to="/simulateur-tresorerie-association" className="text-sm hover:text-blue-400 transition-colors">Simulateur trésorerie</Link></li>
              <li><Link to="/blog" className="text-sm hover:text-blue-400 transition-colors">Blog</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Gestion de trésorerie</h3>
            <ul className="space-y-2">
              <li><Link to="/gestion-tresorerie" className="text-sm hover:text-blue-400 transition-colors">Guide gestion trésorerie</Link></li>
              <li><Link to="/plan-tresorerie" className="text-sm hover:text-blue-400 transition-colors">Plan de trésorerie</Link></li>
              <li><Link to="/prevision-tresorerie" className="text-sm hover:text-blue-400 transition-colors">Prévision de trésorerie</Link></li>
              <li><Link to="/logiciel-tresorerie" className="text-sm hover:text-blue-400 transition-colors">Logiciel de trésorerie</Link></li>
              <li><Link to="/bfr-tresorerie" className="text-sm hover:text-blue-400 transition-colors">BFR et trésorerie</Link></li>
              <li><Link to="/cash-flow-entreprise" className="text-sm hover:text-blue-400 transition-colors">Cash flow entreprise</Link></li>
              <li><Link to="/manque-tresorerie" className="text-sm hover:text-blue-400 transition-colors">Manque de trésorerie</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Par profil</h3>
            <ul className="space-y-2">
              <li><Link to="/gestion-tresorerie-association" className="text-sm hover:text-blue-400 transition-colors">Associations</Link></li>
              <li><Link to="/gestion-tresorerie-pme" className="text-sm hover:text-blue-400 transition-colors">PME</Link></li>
              <li><Link to="/gestion-tresorerie-tpe" className="text-sm hover:text-blue-400 transition-colors">TPE</Link></li>
              <li><Link to="/gestion-tresorerie-agriculteur" className="text-sm hover:text-blue-400 transition-colors">Agriculteurs</Link></li>
              <li><Link to="/tresorerie-startup" className="text-sm hover:text-blue-400 transition-colors">Startups</Link></li>
              <li><Link to="/tresorerie-freelance-independant" className="text-sm hover:text-blue-400 transition-colors">Freelances</Link></li>
              <li><Link to="/tresorerie-ess-economie-sociale" className="text-sm hover:text-blue-400 transition-colors">ESS</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Ressources</h3>
            <ul className="space-y-2">
              <li><Link to="/modele-plan-tresorerie" className="text-sm hover:text-blue-400 transition-colors">Modèle plan trésorerie</Link></li>
              <li><Link to="/tableau-tresorerie-gratuit" className="text-sm hover:text-blue-400 transition-colors">Tableau trésorerie gratuit</Link></li>
              <li><Link to="/excel-vs-logiciel-tresorerie" className="text-sm hover:text-blue-400 transition-colors">Excel vs logiciel</Link></li>
              <li><Link to="/difference-tresorerie-resultat" className="text-sm hover:text-blue-400 transition-colors">Trésorerie vs résultat</Link></li>
              <li><Link to="/subvention-en-retard-tresorerie" className="text-sm hover:text-blue-400 transition-colors">Subvention en retard</Link></li>
              <li><Link to="/stress-test-tresorerie" className="text-sm hover:text-blue-400 transition-colors">Stress test trésorerie</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <p className="text-sm text-gray-400">
              {currentYear} Trezoone. Tous droits réservés.
            </p>
            <div className="flex flex-wrap gap-4 text-sm">
              <Link to="/mentions-legales" className="text-gray-400 hover:text-blue-400 transition-colors">Mentions légales</Link>
              <Link to="/politique-confidentialite" className="text-gray-400 hover:text-blue-400 transition-colors">Politique de confidentialité</Link>
              <Link to="/conditions-generales-utilisation" className="text-gray-400 hover:text-blue-400 transition-colors">CGU</Link>
              <button
                onClick={openPreferences}
                className="text-gray-400 hover:text-blue-400 transition-colors text-left focus:outline-none focus:ring-1 focus:ring-blue-400 rounded"
              >
                Cookies
              </button>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-6 pt-5 text-center">
          <p className="text-xs text-gray-600">
            Développé par{' '}
            <a
              href="https://developpement-web-charente.fr"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-400 transition-colors"
            >
              One System
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
